
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6b42"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6b42"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8TMH", function(module, exports) {

$parcel$export(module.exports, "mapTheme", () => $6e6e1c548dfa6c2f$export$86a37f3e9a93467a);
$parcel$export(module.exports, "applyFXConfig", () => $6e6e1c548dfa6c2f$export$dde7d1e6fdfacdb3);

var $dudJS = parcelRequire("dudJS");
function $6e6e1c548dfa6c2f$export$86a37f3e9a93467a(theme) {
    return {
        bg: theme.bg,
        dotColor: theme.line,
        color: theme.acc
    };
}
function $6e6e1c548dfa6c2f$export$dde7d1e6fdfacdb3(overrides = {}, mapColors = $6e6e1c548dfa6c2f$export$86a37f3e9a93467a) {
    window.FX = {
        ...mapColors((0, $dudJS.readThemeColors)()),
        ...overrides
    };
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ()=>{
        Object.assign(window.FX, mapColors((0, $dudJS.readThemeColors)()));
    });
}

});
parcelRegister("dudJS", function(module, exports) {

$parcel$export(module.exports, "readThemeColors", () => $227f11a6809b1d6b$export$a9b96d9f5d5e256a);
/** Raw theme colour custom properties read directly from CSS. */ function $227f11a6809b1d6b$export$a9b96d9f5d5e256a() {
    const style = getComputedStyle(document.documentElement);
    return {
        bg: style.getPropertyValue("--bg").trim(),
        line: style.getPropertyValue("--line").trim(),
        acc: style.getPropertyValue("--acc").trim(),
        err: style.getPropertyValue("--err").trim()
    };
}

});


parcelRegister("aavnl", function(module, exports) {

$parcel$export(module.exports, "setupFX", () => $97adeba544a4afcb$export$51f1f14f52cb0072);
/* ============================================================================
   Dot-grid number rain
   ----------------------------------------------------------------------------
   Drops random numbers all over the page, snapped to the dot grid. Each number
   is "drawn" stroke-by-stroke along its lines (pen reveal), holds, then fades.

   Drop-in usage:
     1. import { setupFX } from './fx-engine.ts'; setupFX();  (injects its own
        full-page canvas that draws BOTH the dot grid and the numbers).
     2. Tweak live via window.FX. Set FX.bg='' and FX.drawGrid=false to render
        numbers transparently over your own background.
   ============================================================================ */ /** A 2D coordinate pair [x, y] in glyph or pixel space. */ const $97adeba544a4afcb$export$75d3998385cc196f = {
    '0': [
        [
            [
                0,
                0
            ],
            [
                2,
                0
            ],
            [
                2,
                3
            ],
            [
                0,
                3
            ],
            [
                0,
                0
            ]
        ]
    ],
    '1': [
        [
            [
                0,
                1.5
            ],
            [
                2,
                0
            ],
            [
                2,
                3
            ]
        ]
    ],
    '2': [
        [
            [
                0,
                0
            ],
            [
                2,
                0
            ],
            [
                2,
                1.5
            ],
            [
                0,
                3
            ],
            [
                2,
                3
            ]
        ]
    ],
    '3': [
        [
            [
                0,
                0
            ],
            [
                2,
                0
            ],
            [
                0,
                1.5
            ],
            [
                2,
                1.5
            ],
            [
                0,
                3
            ]
        ]
    ],
    '4': [
        [
            [
                0,
                0
            ],
            [
                0,
                1.5
            ],
            [
                2,
                1.5
            ]
        ],
        [
            [
                2,
                0
            ],
            [
                2,
                3
            ]
        ]
    ],
    '5': [
        [
            [
                2,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                1.5
            ],
            [
                2,
                1.5
            ],
            [
                2,
                3
            ],
            [
                0,
                3
            ]
        ]
    ],
    '6': [
        [
            [
                2,
                0
            ],
            [
                0,
                1.5
            ],
            [
                0,
                3
            ],
            [
                2,
                3
            ],
            [
                2,
                1.5
            ],
            [
                0,
                1.5
            ]
        ]
    ],
    '7': [
        [
            [
                0,
                0
            ],
            [
                2,
                0
            ],
            [
                0,
                1.5
            ],
            [
                0,
                3
            ]
        ]
    ],
    '8': [
        [
            [
                0,
                0
            ],
            [
                2,
                0
            ],
            [
                2,
                3
            ],
            [
                0,
                3
            ],
            [
                0,
                0
            ]
        ],
        [
            [
                0,
                1.5
            ],
            [
                2,
                1.5
            ]
        ]
    ],
    '9': [
        [
            [
                0,
                3
            ],
            [
                2,
                1.5
            ],
            [
                2,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                1.5
            ],
            [
                2,
                1.5
            ]
        ]
    ]
};
const $97adeba544a4afcb$export$6237d6142cf24ebd = Object.keys($97adeba544a4afcb$export$75d3998385cc196f);
function $97adeba544a4afcb$export$51f1f14f52cb0072() {
    /* ── Live config ─────────────────────────────────────────────────────────────
     applyFXConfig() (from fx-config-base.ts) pre-populates window.FX before
     this runs. Any field it leaves unset falls back to defaultConfig below,
     so the engine also works stand-alone with defaults only.                */ const defaultConfig = {
        bg: "#000000",
        dotColor: "#303030",
        color: "#ffffff",
        drawGrid: true,
        /* grid ------------------------------------------------------------------ */ dot: 16,
        dotRadius: 1,
        /* numbers --------------------------------------------------------------- */ cellWMin: 2,
        cellWMax: 5,
        maxDigits: 1,
        allowedCharacters: null,
        sequential: false,
        /* animation ------------------------------------------------------------- */ spawnMs: 520,
        drawMs: 750,
        holdMs: 600,
        fadeMs: 1200,
        /* appearance ------------------------------------------------------------ */ glow: 0,
        thickness: 1
    };
    // Fields left unset by the page's applyFXConfig() call fall back to defaultConfig
    const FX = {
        ...defaultConfig,
        ...window.FX
    };
    window.FX = FX;
    /* ── Canvas setup ───────────────────────────────────────────────────────── */ const canvas = document.createElement("canvas");
    canvas.id = "fx-numbers";
    canvas.style.cssText = "position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:0;";
    function mountCanvas() {
        (document.body ?? document.documentElement).appendChild(canvas);
    }
    if (document.body) mountCanvas();
    else document.addEventListener("DOMContentLoaded", mountCanvas);
    function require2DContext(el) {
        const ctx = el.getContext("2d");
        if (!ctx) throw new Error("Canvas 2D context unavailable");
        return ctx;
    }
    const canvasContext = require2DContext(canvas);
    let viewportWidth = 0;
    let viewportHeight = 0;
    let pixelRatio = 1;
    function handleResize() {
        pixelRatio = Math.min(window.devicePixelRatio ?? 1, 2);
        viewportWidth = window.innerWidth;
        viewportHeight = window.innerHeight;
        canvas.width = Math.round(viewportWidth * pixelRatio);
        canvas.height = Math.round(viewportHeight * pixelRatio);
        canvasContext.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    /* ── Offscreen grid canvas ──────────────────────────────────────────────────
     The dot grid is expensive to redraw (hundreds of arc() calls) but changes
     rarely — only on resize or when a grid-related FX property is mutated.
     We draw it once into an offscreen canvas and blit it with drawImage()
     each frame, which is a single GPU copy rather than re-issuing every arc.  */ const offscreenGridCanvas = document.createElement("canvas");
    const gridContext = require2DContext(offscreenGridCanvas);
    let gridCacheKey = "";
    function renderGridToOffscreen() {
        offscreenGridCanvas.width = canvas.width;
        offscreenGridCanvas.height = canvas.height;
        gridContext.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        gridContext.clearRect(0, 0, viewportWidth, viewportHeight);
        if (FX.bg) {
            gridContext.fillStyle = FX.bg;
            gridContext.fillRect(0, 0, viewportWidth, viewportHeight);
        }
        if (FX.drawGrid !== false) {
            const gridSpacing = FX.dot;
            const dotRadius = FX.dotRadius ?? 1.2;
            gridContext.fillStyle = FX.dotColor ?? "#303030";
            // Offset by half a grid step so dots are centred within each cell
            for(let y = gridSpacing * 0.5; y < viewportHeight + gridSpacing; y += gridSpacing)for(let x = gridSpacing * 0.5; x < viewportWidth + gridSpacing; x += gridSpacing){
                gridContext.beginPath();
                gridContext.arc(x, y, dotRadius, 0, Math.PI * 2);
                gridContext.fill();
            }
        }
    }
    /** Returns a string that changes whenever any property affecting the grid changes. */ function computeGridCacheKey() {
        return [
            viewportWidth,
            viewportHeight,
            pixelRatio,
            FX.dot,
            FX.bg,
            FX.drawGrid,
            FX.dotColor,
            FX.dotRadius
        ].join("|");
    }
    /* ── Helpers ─────────────────────────────────────────────────────────────── */ function randomRange(minimum, maximum) {
        return minimum + Math.random() * (maximum - minimum);
    }
    function easeOutCubic(t) {
        return 1 - (1 - t) ** 3;
    }
    /* ── Glyph builder ──────────────────────────────────────────────────────────
     Converts a digit string into pixel-space polyline strokes.

     The glyph coordinate system maps onto the dot grid such that every stroke
     endpoint lands exactly on a dot centre:
       scaleX = (cellWidth  − 1) × gridSpacing / 2   (glyph x spans 0 → 2)
       scaleY = (cellHeight − 1) × gridSpacing / 3   (glyph y spans 0 → 3)

     cellHeight is always (2 × cellWidth − 1), giving an exact 1:2 aspect ratio
     because the glyph spans 2 column-gaps wide and 3 row-gaps tall (2:3 gap
     ratio → 1:1.5 cell ratio → same as the 2-wide × 3-tall glyph grid).       */ function buildGlyphStrokes(digitString, originX, originY, cellWidth, cellHeight, gridSpacing) {
        const scaleX = (cellWidth - 1) * gridSpacing / 2;
        const scaleY = (cellHeight - 1) * gridSpacing / 3;
        const digitAdvancePixels = cellWidth * gridSpacing; // horizontal step per digit incl. 1-dot gap
        const allStrokes = [];
        let totalPathLength = 0;
        for(let digitIndex = 0; digitIndex < digitString.length; digitIndex++){
            const glyphStrokes = $97adeba544a4afcb$export$75d3998385cc196f[digitString[digitIndex]];
            const digitOffsetX = digitIndex * digitAdvancePixels;
            for (const glyphStroke of glyphStrokes){
                const pixelPoints = glyphStroke.map(([glyphX, glyphY])=>[
                        originX + digitOffsetX + glyphX * scaleX,
                        originY + glyphY * scaleY
                    ]);
                let strokeLength = 0;
                for(let pointIndex = 1; pointIndex < pixelPoints.length; pointIndex++)strokeLength += Math.hypot(pixelPoints[pointIndex][0] - pixelPoints[pointIndex - 1][0], pixelPoints[pointIndex][1] - pixelPoints[pointIndex - 1][1]);
                allStrokes.push(pixelPoints);
                totalPathLength += strokeLength;
            }
        }
        return {
            strokes: allStrokes,
            totalPathLength: totalPathLength
        };
    }
    /* ── Active instances ───────────────────────────────────────────────────── */ const activeInstances = [];
    let sequenceIndex = 0;
    function spawnNumberInstance() {
        const gridSpacing = FX.dot;
        const minCellWidth = Math.max(2, Math.round(FX.cellWMin ?? FX.cellW ?? 3));
        const maxCellWidth = Math.max(minCellWidth, Math.round(FX.cellWMax ?? minCellWidth));
        const cellWidth = minCellWidth + (Math.random() * (maxCellWidth - minCellWidth + 1) | 0);
        /* Height formula: (2 × width − 1) dots ensures the cell spans exactly
       (width − 1) column-gaps wide and (height − 1) = (2width − 2) row-gaps tall,
       matching the 1:2 aspect ratio of the glyph coordinate grid (2 cols : 3 rows → 2:3 gaps → 1:1.5 → ×2 = 1:2). */ const cellHeight = 2 * cellWidth - 1;
        /* Choose digit string from the active character pool. */ const digitCount = Math.max(1, Math.min(FX.maxDigits, 1 + (Math.random() * FX.maxDigits | 0)));
        const characterPool = FX.allowedCharacters && FX.allowedCharacters.length > 0 ? FX.allowedCharacters : $97adeba544a4afcb$export$6237d6142cf24ebd;
        let digitString;
        if (FX.sequential) {
            const characters = [];
            for(let i = 0; i < digitCount; i++){
                characters.push(characterPool[sequenceIndex % characterPool.length]);
                sequenceIndex++;
            }
            digitString = characters.join("");
        } else digitString = Array.from({
            length: digitCount
        }, ()=>characterPool[Math.random() * characterPool.length | 0]).join("");
        if (!digitString) return;
        /* Compute bounding box in pixels. */ const digitAdvancePixels = cellWidth * gridSpacing;
        const widthPixels = (digitString.length - 1) * digitAdvancePixels + (cellWidth - 1) * gridSpacing;
        const heightPixels = (cellHeight - 1) * gridSpacing;
        // Bail early if the number would not fit with at least one dot of padding on each edge
        if (widthPixels + gridSpacing * 2 > viewportWidth) return;
        if (heightPixels + gridSpacing * 2 > viewportHeight) return;
        /* Snap the origin to a dot centre. Because advances are whole-dot multiples,
       all glyph corners automatically land on dot centres.                      */ const maxGridColumn = Math.floor((viewportWidth - widthPixels - gridSpacing) / gridSpacing);
        const maxGridRow = Math.floor((viewportHeight - heightPixels - gridSpacing) / gridSpacing);
        if (maxGridColumn < 0 || maxGridRow < 0) return;
        let originX = 0, originY = 0, centerX = 0, centerY = 0;
        let placementSucceeded = false;
        let placementAttempts = 0;
        /* Try up to 24 random grid positions, rejecting any that overlap a
       currently-visible instance (drawing, holding, or fading — all are still
       on screen). Padding adds one dot of breathing room beyond a bare touch. */ const placementPadding = gridSpacing;
        do {
            const gridColumn = Math.random() * (maxGridColumn + 1) | 0;
            const gridRow = Math.random() * (maxGridRow + 1) | 0;
            originX = gridColumn * gridSpacing + gridSpacing * 0.5;
            originY = gridRow * gridSpacing + gridSpacing * 0.5;
            centerX = originX + widthPixels / 2;
            centerY = originY + heightPixels / 2;
            placementSucceeded = true;
            for (const existingInstance of activeInstances){
                /* True AABB overlap test using each instance's own half-width and
           half-height (not a single width-derived value for both axes). */ const xOverlap = Math.abs(existingInstance.centerX - centerX) < (existingInstance.widthPixels + widthPixels) / 2 + placementPadding;
                const yOverlap = Math.abs(existingInstance.centerY - centerY) < (existingInstance.heightPixels + heightPixels) / 2 + placementPadding;
                if (xOverlap && yOverlap) {
                    placementSucceeded = false;
                    break;
                }
            }
        }while (!placementSucceeded && ++placementAttempts < 24);
        if (!placementSucceeded) return;
        const { strokes: strokes, totalPathLength: totalPathLength } = buildGlyphStrokes(digitString, originX, originY, cellWidth, cellHeight, gridSpacing);
        activeInstances.push({
            strokes: strokes,
            totalPathLength: totalPathLength,
            lineWidth: Math.max(1.5, gridSpacing * 0.1 * (cellWidth / 3)),
            widthPixels: widthPixels,
            heightPixels: heightPixels,
            centerX: centerX,
            centerY: centerY,
            age: 0,
            drawMs: FX.drawMs * randomRange(0.85, 1.15),
            holdMs: FX.holdMs * randomRange(0.8, 1.2),
            fadeMs: FX.fadeMs * randomRange(0.85, 1.15),
            baseAlpha: randomRange(0.8, 1)
        });
    }
    /* ── Stroke reveal ──────────────────────────────────────────────────────────
     Draws `revealFraction` (0..1) of the instance's total path length.
     Strokes are traversed in order. The final partially-covered segment is
     clipped by linear interpolation so the pen appears to move continuously.  */ function drawGlyphReveal(instance, revealFraction) {
        if (revealFraction >= 1) {
            // Fast path: all strokes are fully visible
            for (const strokePoints of instance.strokes){
                canvasContext.beginPath();
                canvasContext.moveTo(strokePoints[0][0], strokePoints[0][1]);
                for(let pointIndex = 1; pointIndex < strokePoints.length; pointIndex++)canvasContext.lineTo(strokePoints[pointIndex][0], strokePoints[pointIndex][1]);
                canvasContext.stroke();
            }
            return;
        }
        const targetPathLength = revealFraction * instance.totalPathLength;
        let accumulatedLength = 0;
        outer: for (const strokePoints of instance.strokes){
            canvasContext.beginPath();
            canvasContext.moveTo(strokePoints[0][0], strokePoints[0][1]);
            for(let pointIndex = 1; pointIndex < strokePoints.length; pointIndex++){
                const segmentStart = strokePoints[pointIndex - 1];
                const segmentEnd = strokePoints[pointIndex];
                const segmentLength = Math.hypot(segmentEnd[0] - segmentStart[0], segmentEnd[1] - segmentStart[1]);
                if (accumulatedLength + segmentLength <= targetPathLength) {
                    canvasContext.lineTo(segmentEnd[0], segmentEnd[1]);
                    accumulatedLength += segmentLength;
                } else {
                    // Interpolate to the exact point where the reveal front sits
                    const segmentProgress = segmentLength > 0 ? Math.max(0, (targetPathLength - accumulatedLength) / segmentLength) : 0;
                    canvasContext.lineTo(segmentStart[0] + (segmentEnd[0] - segmentStart[0]) * segmentProgress, segmentStart[1] + (segmentEnd[1] - segmentStart[1]) * segmentProgress);
                    canvasContext.stroke();
                    break outer; // reveal front is within this segment — stop drawing
                }
            }
            canvasContext.stroke();
        }
    }
    /* ── Animation loop ─────────────────────────────────────────────────────── */ let lastFrameTime = performance.now();
    let spawnAccumulator = 0;
    function animationFrame(now) {
        /* Cap delta to 60 ms so a tab becoming visible after being hidden doesn't
       trigger a burst of back-logged spawns.                                   */ const deltaTime = Math.min(now - lastFrameTime, 60);
        lastFrameTime = now;
        canvasContext.clearRect(0, 0, viewportWidth, viewportHeight);
        // Blit the cached grid, rebuilding it lazily only when a grid property changes
        const currentGridKey = computeGridCacheKey();
        if (currentGridKey !== gridCacheKey) {
            gridCacheKey = currentGridKey;
            renderGridToOffscreen();
        }
        if (FX.drawGrid !== false || FX.bg) canvasContext.drawImage(offscreenGridCanvas, 0, 0, viewportWidth, viewportHeight);
        /* Accumulate elapsed time and spawn as many instances as the interval allows.
       The guard prevents an infinite loop if spawnMs is set to 0 or near-zero.  */ spawnAccumulator += deltaTime;
        let spawnLoopGuard = 0;
        // Derived from how many full lifecycles fit in flight at the current spawn cadence.
        const effectiveMax = Math.ceil((FX.drawMs + FX.holdMs + FX.fadeMs) / FX.spawnMs);
        while(spawnAccumulator >= FX.spawnMs && spawnLoopGuard++ < 64){
            spawnAccumulator -= FX.spawnMs;
            if (activeInstances.length < effectiveMax) spawnNumberInstance();
        }
        if (spawnLoopGuard >= 64) spawnAccumulator = 0; // safety reset
        canvasContext.lineJoin = "miter";
        canvasContext.lineCap = "round";
        canvasContext.strokeStyle = FX.color;
        canvasContext.shadowColor = FX.color;
        // Traverse backwards so splice() inside the loop doesn't skip entries
        for(let instanceIndex = activeInstances.length - 1; instanceIndex >= 0; instanceIndex--){
            const instance = activeInstances[instanceIndex];
            instance.age += deltaTime;
            let currentAlpha;
            let revealFraction;
            if (instance.age < instance.drawMs) {
                revealFraction = easeOutCubic(instance.age / instance.drawMs);
                // Ramp opacity in quickly at the very start to avoid a harsh pop-in
                currentAlpha = Math.min(1, instance.age / 120);
            } else if (instance.age < instance.drawMs + instance.holdMs) {
                revealFraction = 1;
                currentAlpha = 1;
            } else {
                const fadeProgress = (instance.age - instance.drawMs - instance.holdMs) / instance.fadeMs;
                if (fadeProgress >= 1) {
                    activeInstances.splice(instanceIndex, 1);
                    continue;
                }
                revealFraction = 1;
                currentAlpha = 1 - fadeProgress;
            }
            canvasContext.globalAlpha = currentAlpha * instance.baseAlpha;
            canvasContext.lineWidth = Math.max(1.5, instance.lineWidth * FX.thickness);
            canvasContext.shadowBlur = FX.glow;
            drawGlyphReveal(instance, revealFraction);
        }
        // Reset state that persists across draw calls
        canvasContext.globalAlpha = 1;
        canvasContext.shadowBlur = 0;
        requestAnimationFrame(animationFrame);
    }
    requestAnimationFrame(animationFrame);
}

});


//# sourceMappingURL=repo.ac4325b5.js.map
